// extracted by mini-css-extract-plugin
export default {"h2__Product":"product_h2__Product__BVjuI","ul__Product":"product_ul__Product__1hEtB"};